import {gql} from "@apollo/client";

export const GET_CUSTOM_ATTRIBUTES_SETUP = gql`
	query Query(
		$stage: String
		$id: UUID!
	) {
		customAttributeSetup(
			stage: $stage
			first: 1
			where:{
				id: {
					eq: $id
				}
			}
		) {
			nodes {
				id
				description
				mapping
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

export const GET_ALL_CUSTOM_ATTRIBUTES_SETUP = gql`
	query Query(
		$stage: String
	) {
		customAttributeSetup(
			stage: $stage
			first: 5000
			order: [ { description: ASC } ]
		) {
			nodes {
				id
				description
				mapping
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

export const EXISTS_CUSTOM_ATTRIBUTES_SETUP = gql`
	query Query(
		$stage: String
		$description: String
		$mapping: String
	) {
		customAttributeSetup(
			stage: $stage
			first: 5
			where:{
				or: [{
					description:{
						eq:$description
					}},
					{
						mapping:{
							eq:$mapping
						}
					}
				]
			}
		) {
			nodes {
				id
			}
		}
	}
`;

export const CUSTOM_ATTRIBUTES_SETUP_OVERVIEW = gql`
	query Query(
		$stage: String
		$first: Int
		$after: String
		$before: String
		$where: CustomAttributeSetupFilterInput
		$order: [CustomAttributeSetupSortInput!]
	) {
		customAttributeSetup(
			stage: $stage
			first: $first
			after: $after
			before: $before
			where: $where
			order: $order
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				id
				description
				mapping
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

export const PRODUCT_CUSTOM_ATTRIBUTE_BULK_UPDATE= gql`
	mutation Mutation($batch: CustomAttributeBulkUpdateBatchInput!,$stage: String)
	{
		productCustomAttributeBulkUpdate(batch:$batch,stage: $stage)
		{
			successful
			errors {
				message
				code
			}
		}
	}
`;


export const SUPPLIER_CUSTOM_ATTRIBUTE_BULK_UPDATE= gql`
	mutation Mutation($batch: CustomAttributeBulkUpdateBatchInput!,$stage: String)
	{
		supplierCustomAttributeBulkUpdate(batch:$batch,stage:$stage)
		{
			successful
			errors {
				message
				code
			}
		}
	}
`;

export const PUT_CUSTOM_ATTRIBUTES_SETUP = gql`
	mutation Mutation(
	$customAttributeSetup: CustomAttributeSetupInput! $stage: String
	) {
		putCustomAttributeSetup(
			customAttributeSetup: $customAttributeSetup
			stage: $stage
		) {
			customAttributeSetup {
				id
			}
			errors {
				message
				code
			}
		}
	}
`;

export const DELETE_CUSTOM_ATTRIBUTES_SETUP = gql`
	mutation Mutation(
		$id: UUID! $stage: String
	) {
		deleteCustomAttributeSetup(
			id: $id
			stage: $stage
		) {
			productsUpdated
			suppliersUpdated
			errors {
				message
				code
			}
		}
	}
`;

export const PRODUCT_COMMISSIONS_OVERVIEW = gql`
	query Query(
		$stage: String
		$first: Int
		$after: String
		$where: ProductCommissionFilterInput
		$order: [ProductCommissionSortInput!]
	) {
		productCommissions(
			stage: $stage
			first: $first
			after: $after
			where: $where
			order: $order
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				krn
				state
				commissionConfigs {
					startDate
					commissionNetPremiumFactor
					commissionNetPremiumFactorPerBillablePerson
					commissionAmountPerMonth
					numberOfMonths
					commissionAmountPerBillablePerson
					commissionAmountFixedFee
					renewalCommissionInstallmentAmount
					renewalCommissionInstallmentNumberOfMonths
					renewalCommissionInstallmentAmountLink
				}
				commissionShareConfigs {
					startDate
					partnerFixedAmount
					partnerCommissionFactor
					subPartnerCommissions {
						partnerName
					 	partnerFixedAmount
						partnerCommissionFactor
					}
				}
				id
				version
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

export const PRODUCT_COMMISSIONS_DETAILS = gql`
	query Query(
		$stage: String
		$krn: String!
	) {
		productCommissions(
			stage: $stage
			where: {
				krn: {
					eq: $krn
				}
			}
		) {
			nodes {
				krn
				state
				commissionConfigs {
					startDate
					commissionNetPremiumFactor
					commissionNetPremiumFactorPerBillablePerson
					commissionAmountPerMonth
					numberOfMonths
					commissionAmountPerBillablePerson
					commissionAmountFixedFee
					renewalCommissionInstallmentAmount
					renewalCommissionInstallmentNumberOfMonths
					renewalCommissionInstallmentAmountLink
				}
				commissionShareConfigs {
					startDate
					partnerFixedAmount
					partnerCommissionFactor
					subPartnerCommissions {
						partnerName
					 	partnerFixedAmount
						partnerCommissionFactor
					}
				}
				id
				version
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

export const PUT_PRODUCT_COMMISSION = gql`
	mutation Mutation(
		$stage: String
		$productCommission: ProductCommissionInput!
	) {
		putProductCommission(
			stage: $stage
			productCommission: $productCommission
		) {
			krn
			errors {
				message
				code
			}
		}
	}
`;

export const PRODUCT_SUPPLIERS_OVERVIEW = gql`
	query Query(
		$stage: String
		$first: Int
		$after: String
		$where: ProductSupplierFilterInput
		$order: [ProductSupplierSortInput!]
	) {
		productSuppliers(
			stage: $stage
			first: $first
			after: $after
			where: $where
			order: $order
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				krn
				name
				legalName
				state
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

export const PRODUCT_SUPPLIER_DETAILS = gql`
	query Query(
		$stage: String
		$krn: String!
	) {
		productSuppliers(
			stage: $stage
			where: {
				krn: {
					eq: $krn
				}
			}
		) {
			nodes {
				refKey
				krn
				name
				legalName
				externalIds {
					providerKrn
					externalSupplierId
				}
				porCompany
				state
				nameLogoUrl
				addresses {
					addressType
					city
					country
					houseNumber
					houseNumberAddition
					houseLetter
					postalCode
					street
				}
				customAttributes {
					description
					value
				}
				informationContacts {
					type
					replyNumber
					phoneNumber
					emailAddress
				}
				advantages {
					description
					productCategory
					clientName
				}
				disadvantages {
					description
					productCategory
					clientName
				}
				features {
					name
					value
					productCategory
					clientName
				}
				taskDivisions {
					creationDateTime
					lastModifiedBy
					lastModifiedDateTime
					productCategory
					clientName
					name
					value
					version
				}
				sustainabilityScore {
					source
					score
					clientName
				}
				sellingPoints {
					creationDateTime
					lastModifiedBy
					lastModifiedDateTime
					sellingPointType
					productCategory
					orderType
					description
					value
					clientName
					version
				}
				howItWorks {
					creationDateTime
					lastModifiedBy
					lastModifiedDateTime
					productCategory
					typeName
					value
					clientName
					version
				}
				about
				googleAnalyticsMapping {
					googleAnalyticsValueMapping
					coverages
					productTypes
				}
				id
				version
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

export const PRODUCTS_OVERVIEW = gql`
	query Query(
		$stage: String
		$first: Int
		$after: String
		$where: ProductExtendedFilterInput
		$order: [ProductExtendedSortInput!]
	) {
		productsExtended(
			stage: $stage
			first: $first
			after: $after
			where: $where
			order: $order
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				krn
				externalId
				dataProviderKrn
				name
				description
				productSupplierKrn
				state
				productType
				productTypeKrn
				orderType
				productCategory
				affiliateUrl
				insuranceCardUrl
				termsAndConditionsUrl
				clientName
				supplierGenericProduct
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
				supplierName
			}
		}
	}
`;

export const PRODUCTS_FOR_SUPPLIER = gql`
	query Query(
		$stage: String
		$productSupplierKrn: String
	) {
		products(
			stage: $stage
			where: {
				productSupplierKrn: {
					eq: $productSupplierKrn
				}
			}
		) {
			nodes {
				krn
				externalId
				dataProviderKrn
				name
				description
				productSupplierKrn
				state
				productType
				productTypeKrn
				orderType
				productCategory
				affiliateUrl
				insuranceCardUrl
				termsAndConditionsUrl
				clientName
				supplierGenericProduct
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
				customAttributes {
					description
					value
				}
			}
		}
	}
`;

export const COPY_PRODUCTS = gql`
	mutation Mutation(
		$krns: [String!]!
		$toClient: String!
		$stage: String
	) {
		copyProducts(
		    stage: $stage
			krns: $krns
			toClient: $toClient
		) {
		    copyCount
			errors {
				message
				code
			}
		}
	}
`;

export const GET_EXPORT_TEMPLATE = gql`
	query GetExportTemplate($item: TemplateExportRequestInput!,$stage: String)  {
		exportTemplate(item:$item,stage:$stage)
		{
			url
		}
	}

`;

export const GET_UPLOAD_URL = gql`
	query GetUploadUrl($stage: String) {
		uploadUrl(stage:$stage)
		{
			userName
			url
			fileName
		}
	}
`;

export const PRODUCT_DETAILS = gql`
	query Query(
		$stage: String
		$krn: String!
	) {
		products(
			stage: $stage
			where: {
				krn: {
					eq: $krn
				}
			}
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				krn
				externalId
				dataProviderKrn
				name
				description
				productSupplierId
				productSupplierKrn
				state
				productType
				productTypeKrn
				orderType
				productCategory
				affiliateUrl
				testScores {
					source
					score
				}
				insuranceCardUrl
				termsAndConditionsUrl
				clientName
				supplierGenericProduct
				correspondingMoneyViewExternalId
				sellingPoints {
					description
					value
				}
				customAttributes {
					description
					value
				}
				productIncentives {
					productIncentiveDetailsKrn
					active
				}
				coverages {
                    category
                    eventDescription
                    definition
                    coverageDays
                }
				eventInformation {
					id
					category
					name
					definition
					duration
				}
				id
				version
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

export const COMPARATOR_CONFIG_OVERVIEW = gql`
	query Query(
		$stage: String
		$first: Int
		$after: String
		$before: String
		$where: ComparatorConfigFilterInput
		$order: [ComparatorConfigSortInput!]
	) {
		comparatorConfigs(
			stage: $stage
			first: $first
			after: $after
			before: $before
			where: $where
			order: $order
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				krn
				clientName
				comparatorId
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

export const COMPARATOR_CONFIG_DETAILS = gql`
	query Query(
		$stage: String
		$tenant: String!
		$comparatorId: String!
	) {
		comparatorConfigs(
			stage: $stage
			where: {
				clientName: { eq: $tenant }
				comparatorId: { eq: $comparatorId }
			}
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				id
				krn
				clientName
				comparatorId
				suppliers {
					supplierId
					supplierKrn
					canCalculate
					canCommit
					productExclusions {
						productId
						productKrn
						visible
					}
				}
				afmLicense {
					number
					name
					isUrl
					url
				}
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

export const EXISTS_COMPARATOR_CONFIG_ITEM = gql`
	query Query(
		$stage: String
		$tenant: String!
		$comparatorId: String!
	)  {
		comparatorConfigs(
			stage: $stage
			first: 1
			where: {
				clientName: { eq: $tenant }
				comparatorId: { eq: $comparatorId }
			}
		) {
			nodes {
				id
			}
		}
	}
`;

export const PRODUCT_INCENTIVE_OVERVIEW = gql`
	query Query(
		$stage: String
		$first: Int
		$after: String
		$where: ProductIncentiveDetailsFilterInput
		$order: [ProductIncentiveDetailsSortInput!]
	) {
		productIncentiveDetails(
			stage: $stage
			first: $first
			after: $after
			where: $where
			order: $order
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				id
				krn
				clientName
				productIncentiveType
				label
				state
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

export const PRODUCT_INCENTIVE_SUMMARY = gql`
	query GetProductIncentiveSummary($productIncentiveDetailsKrn: [String!])
	{
		productIncentiveSummary(productIncentiveDetailsKrn:$productIncentiveDetailsKrn)
		{
			productIncentiveDetailsKrn
			totalCodes
			availableCodes
		}
	}
`;
export const PRODUCT_INCENTIVE_DETAILS = gql`
	query Query(
		$stage: String
		$krn: String!
	) {
		productIncentiveDetails(
			stage: $stage
			where: { krn: { eq: $krn } }
		) {
			nodes {
				id
				krn
				clientName
				productIncentiveType
				label
				state
			}
		}
	}
`;

export const PRODUCT_INCENTIVE_DICTIONARY = gql`
	query Query(
		$krn: String!
	) {
		productIncentiveDictionary(
			where: {
				productIncentiveDetailsKrn: { eq: $krn }
				consumedBy: { eq: null }
			}
		) {
			nodes {
				code
			}
		}
	}
`;

export const SUPPLIER_INDEX = gql`
	query Query(
		$stage: String
	) {
		productSuppliers(
			stage: $stage
			first: 999999
			order: [ { name: ASC } ]
		) {
			nodes {
				id
				krn
				name
				legalName
				customAttributes {
					description
					value
				}
			}
		}
	}
`;

export const PRODUCT_INDEX = gql`
	query Query(
		$stage: String
		$tenant: String!
		$productTypeKrns: [String!]!
	) {
		products(
			stage: $stage
			first: 999999
			where: {
				clientName: { eq: $tenant }
				productTypeKrn: { in: $productTypeKrns }
			}
		) {
			nodes {
				id
				krn
				name
				productSupplierId
			}
		}
	}
`;

export const GET_EXPORTER_OPTIONS = gql`
	query GetExporterOptions
	{
		exporterOptions
		{
			items
			{
				exporterName
			}
		}
	
	}
`;

export const PRODUCT_INCENTIVE_DETAILS_INDEX = gql`
	query Query(
		$stage: String
		$tenant: String!
	) {
		productIncentiveDetails(
			stage: $stage
			first: 999999
			where: {
				clientName: { eq: $tenant }
			}
		) {
			nodes {
				id
				krn
				productIncentiveType
				label
			}
		}
	}
`;

export const ANALYZE_CHANGES = gql`
	query Query {
		analyzeChanges {
			stages
			comparatorConfigs {
				krn
				clientName
				comparatorId
				suppliers {
					supplierId
					supplierKrn
					canCommit
					canCalculate
					productExclusions {
						productId
						productKrn
						visible
					}
				}
				afmLicense {
					number
					name
					isUrl
					url
				}
				id
			}
			customAttributeSetup  {
				id
				description
				mapping
			}
			products {
				productSupplierKrn
				krn
				externalId
				dataProviderKrn
				name
				description
				productSupplierId
				state
				productType
				productTypeKrn
				orderType
				productCategory
				affiliateUrl
				testScores {
					source
					score
				}
				insuranceCardUrl
				termsAndConditionsUrl
				clientName
				supplierGenericProduct
				correspondingMoneyViewExternalId
				sellingPoints {
					description
					value
				}
				customAttributes {
					description
					value
				}
				productIncentives {
					productIncentiveDetailsKrn
					active
				}
				coverages {
                    category
                    eventDescription
                    definition
                    coverageDays
                }
				eventInformation {
					id
					category
					name
					definition
					duration
				}
				id
			}
			suppliers {
				krn
				name
				legalName
				externalIds {
					providerKrn
					externalSupplierId
				}
				porCompany
				state
				nameLogoUrl
				addresses {
					addressType
					city
					country
					houseNumber
					houseNumberAddition
					houseLetter
					postalCode
					street
				}
				informationContacts {
					type
					replyNumber
					phoneNumber
					emailAddress
				}
				advantages {
					description
					productCategory
					clientName
				}
				disadvantages {
					description
					productCategory
					clientName
				}
				features {
					name
					value
					productCategory
					clientName
				}
				taskDivisions {
					productCategory
					clientName
					name
					value
				}
				sustainabilityScore {
					source
					score
					clientName
				}
				sellingPoints {
					orderType
					clientName
					productCategory
					description
					value
					sellingPointType
				}
				howItWorks {
					productCategory
					typeName
					value
					clientName
				}
				about
				googleAnalyticsMapping {
					googleAnalyticsValueMapping
					coverages
					productTypes
				}
				customAttributes {
					description
					value
				}
				id
			}
			incentiveDetails {
				id
				krn
				clientName
				productIncentiveType
				label
				state
			}
			productCommissions {
				id
				krn
				state
				commissionConfigs {
					startDate
					commissionNetPremiumFactor
					commissionNetPremiumFactorPerBillablePerson
					commissionAmountPerMonth
					numberOfMonths
					commissionAmountPerBillablePerson
					commissionAmountFixedFee
					renewalCommissionInstallmentAmount
					renewalCommissionInstallmentNumberOfMonths
					renewalCommissionInstallmentAmountLink
				}
				commissionShareConfigs {
					startDate
					partnerFixedAmount
					partnerCommissionFactor
					subPartnerCommissions {
						partnerName
					 	partnerFixedAmount
						partnerCommissionFactor
					}
				}
			}
			partnerHierarchy {
                id
				clientName
				parent
			}
		}
	}
`;

export const PUT_PRODUCT_SUPPLIER = gql`
	mutation Mutation(
		$stage: String
		$productSupplier: ProductSupplierWithIdInput!
	) {
		putProductSupplier(
			stage: $stage
			productSupplier: $productSupplier
		) {
			supplier {
				id
			}
			errors {
				message
				code
			}
		}
	}
`;

export const PUT_PRODUCT = gql`
	mutation Mutation(
		$stage: String
		$product: ProductWithIdInput!
	) {
		putProduct(
			stage: $stage
			product: $product
		) {
			product {
				id
			}
			errors {
				message
				code
			}
		}
	}
`;

export const PUT_COMPARATOR_CONFIG = gql`
	mutation Mutation(
		$stage: String
		$comparatorConfig: ComparatorConfigWithIdInput!
	) {
		putComparatorConfig(
			stage: $stage
			comparatorConfig: $comparatorConfig
		) {
			comparatorConfig {
				id
			}
			errors {
				message
				code
			}
		}
	}
`;

export const PUT_PRODUCT_INCENTIVE_DETAILS = gql`
	mutation Mutation(
		$stage: String
		$productIncentiveDetails: ProductIncentiveDetailsInput!
	) {
		putProductIncentiveDetails(
			stage: $stage
			productIncentiveDetails: $productIncentiveDetails
		) {
			krn
			errors {
				message
				code
			}
		}
	}
`;

export const ADD_PRODUCT_INCENTIVE_CODES = gql`
	mutation Mutation(
		$productIncentiveDetailsKrn: String!
		$codes: [String!]!
	) {
		bulkCreateProductIncentiveDictionary(
			productIncentiveDetailsKrn: $productIncentiveDetailsKrn
			codes: $codes
		)
	}
`;

export const PARTNER_HIERARCHY_OVERVIEW = gql`
	query Query(
		$stage: String
		$first: Int
		$after: String
		$before: String
		$where: PartnerHierarchyFilterInput
		$order: [PartnerHierarchySortInput!]
	) {
		partnerHierarchy(
			stage: $stage
			first: $first
			after: $after
			before: $before
			where: $where
			order: $order
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			nodes {
				id
				clientName
				parent
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

export const PUT_PARTNER_HIERARCHY = gql`
	mutation Mutation(
		$stage: String
		$partnerHierarchy: PartnerHierarchyInput!
	) {
		putPartnerHierarchy(
			stage: $stage
			partnerHierarchy: $partnerHierarchy
		) {
		    partnerHierarchy {
			   clientName
			}
			errors {
				message
				code
			}
		}
	}
`;

export const EXISTS_PARTNER_HIERARCHY = gql`
	query Query(
		$stage: String
		$clientName: String
	) {
		partnerHierarchy(
			stage: $stage
			first: 1
			where:{ clientName:{
				eq:$clientName
				}
			}
		) {
			nodes {
				id
			}
		}
	}
`;

export const GET_PARTNER_HIERARCHY = gql`
	query Query(
		$stage: String
		$id: UUID!
	) {
		partnerHierarchy (
			stage: $stage
			first: 1
			where:{ id:{
				eq:$id
				}
			}
		) {
			nodes {
				id
				clientName
				parent
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;

export const PARTNER_HIERARCHY_INDEX = gql`
	query Query(
		$stage: String
	) {
		partnerHierarchy (
			stage: $stage
			first: 999999
			where: {
				parent: { neq: null }
			}
		) {
			nodes {
				id
				clientName
				parent
				creationDateTime
				lastModifiedDateTime
				lastModifiedBy
			}
		}
	}
`;
